import { render, staticRenderFns } from "./despacho.vue?vue&type=template&id=e45ef1d4&"
import script from "./despacho.vue?vue&type=script&lang=js&"
export * from "./despacho.vue?vue&type=script&lang=js&"
import style0 from "./despacho.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports